export default function ComicThumbnail({
  className,
  processing = false,
}: {
  className?: string;
  /** Outline-only sheets (no white fill), for in-progress batch tiles. */
  processing?: boolean;
}) {
  const sheetFill = processing ? 'none' : 'white';

  return (
    <svg
      className={className}
      viewBox="0 0 90 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.9619 1H50.6689C52.4285 1.00002 53.9379 1.12595 55.2061 1.36816L55.2168 1.37012L55.2266 1.37109C56.4605 1.5806 57.5939 1.98556 58.6338 2.58203L58.6426 2.58594L58.6504 2.59082C59.6876 3.15987 60.785 4.02024 61.9395 5.19922L61.9424 5.20117L84.4531 28.042L84.459 28.0479C85.6717 29.2575 86.5491 30.3954 87.1201 31.457L87.1338 31.4824C87.7279 32.513 88.1346 33.6682 88.3457 34.958V34.9619C88.5627 36.2608 88.6758 37.8873 88.6758 39.8535V78.7217C88.6757 83.1591 87.5443 86.3513 85.4424 88.4736L85.4385 88.4775C83.3397 90.6222 80.1589 91.7773 75.7139 91.7773H29.9619C25.5138 91.7773 22.3317 90.6351 20.2334 88.5166C18.1325 86.3953 17.0001 83.1897 17 78.7217V14.0557C17 9.61818 18.1314 6.42608 20.2334 4.30371L20.2373 4.29883C22.3361 2.15421 25.517 1 29.9619 1Z"
        fill={sheetFill}
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M57 1V16.5C57 25.3366 64.1634 32.5 73 32.5H88.5"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M21.9619 9H42.6689C44.4285 9.00002 45.9379 9.12595 47.2061 9.36816L47.2168 9.37012L47.2266 9.37109C48.4605 9.5806 49.5939 9.98556 50.6338 10.582L50.6426 10.5859L50.6504 10.5908C51.6876 11.1599 52.785 12.0202 53.9395 13.1992L53.9424 13.2012L76.4531 36.042L76.459 36.0479C77.6717 37.2575 78.5491 38.3954 79.1201 39.457L79.1338 39.4824C79.7279 40.513 80.1346 41.6682 80.3457 42.958V42.9619C80.5627 44.2608 80.6758 45.8873 80.6758 47.8535V86.7217C80.6757 91.1591 79.5443 94.3513 77.4424 96.4736L77.4385 96.4775C75.3397 98.6222 72.1589 99.7773 67.7139 99.7773H21.9619C17.5138 99.7773 14.3317 98.6351 12.2334 96.5166C10.1325 94.3953 9.00008 91.1897 9 86.7217V22.0557C9.00003 17.6182 10.1314 14.4261 12.2334 12.3037L12.2373 12.2988C14.3361 10.1542 17.517 9 21.9619 9Z"
        fill={sheetFill}
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M49 9V24.5C49 33.3366 56.1634 40.5 65 40.5H80.5"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M13.9619 17H34.6689C36.4285 17 37.9379 17.1259 39.2061 17.3682L39.2168 17.3701L39.2266 17.3711C40.4605 17.5806 41.5939 17.9856 42.6338 18.582L42.6426 18.5859L42.6504 18.5908C43.6876 19.1599 44.785 20.0202 45.9395 21.1992L45.9424 21.2012L68.4531 44.042L68.459 44.0479C69.6717 45.2575 70.5491 46.3954 71.1201 47.457L71.1338 47.4824C71.7279 48.513 72.1346 49.6682 72.3457 50.958V50.9619C72.5627 52.2608 72.6758 53.8873 72.6758 55.8535V94.7217C72.6757 99.1591 71.5443 102.351 69.4424 104.474L69.4385 104.478C67.3397 106.622 64.1589 107.777 59.7139 107.777H13.9619C9.51384 107.777 6.3317 106.635 4.2334 104.517C2.13248 102.395 1.00008 99.1897 1 94.7217V30.0557C1.00003 25.6182 2.13144 22.4261 4.2334 20.3037L4.2373 20.2988C6.33612 18.1542 9.51696 17 13.9619 17Z"
        fill={sheetFill}
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M41 17V32.5C41 41.3366 48.1634 48.5 57 48.5H72.5"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M52.8989 71.9917C50.6391 71.9917 49.3242 70.5844 49.3242 68.8074C49.3242 67.02 50.6904 65.6436 52.9503 65.6436C54.0699 65.6436 54.789 65.962 55.282 66.3318V67.7288C54.8198 67.3487 54.1521 67.0406 53.2995 67.0406C51.9025 67.0406 51.0705 67.7904 51.0705 68.8074C51.0705 69.8038 51.8409 70.5947 53.3303 70.5947C54.1316 70.5947 54.8403 70.2866 55.3129 69.9373V71.2727C54.6452 71.7349 53.8645 71.9917 52.8989 71.9917Z"
        fill="currentColor"
      />
      <path
        d="M46.4929 71.8171V66.075H48.1673V71.8171H46.4929ZM47.3352 65.6025C46.7703 65.6025 46.3594 65.2532 46.3594 64.791C46.3594 64.3287 46.7805 64 47.3352 64C47.8899 64 48.3008 64.3287 48.3008 64.791C48.3008 65.2532 47.8899 65.6025 47.3352 65.6025Z"
        fill="currentColor"
      />
      <path
        d="M35.2773 71.8171V65.8901H36.9312V67.1946C37.2804 66.1263 37.9276 65.6436 38.9239 65.6436C39.8998 65.6436 40.5778 66.188 40.8448 67.133C41.1838 66.1263 41.8618 65.6436 42.889 65.6436C44.2654 65.6436 45.0256 66.5578 45.0256 68.191V71.8171H43.3512V68.5506C43.3512 67.5953 42.9712 67.0611 42.2213 67.0611C41.4098 67.0611 40.9886 67.6774 40.9886 68.5506V71.8171H39.3246V68.4068C39.3246 67.5953 38.9342 67.0611 38.1946 67.0611C37.4037 67.0611 36.9414 67.7391 36.9414 68.7252V71.8171H35.2773Z"
        fill="currentColor"
      />
      <path
        d="M30.658 71.9917C28.5112 71.9917 27.1758 70.5844 27.1758 68.7971C27.1758 66.9995 28.5112 65.6436 30.658 65.6436C32.8254 65.6436 34.1403 66.9995 34.1403 68.7971C34.1403 70.5844 32.8254 71.9917 30.658 71.9917ZM30.658 70.6461C31.7674 70.6461 32.4454 69.8757 32.4454 68.8176C32.4454 67.7493 31.7674 67.0097 30.658 67.0097C29.5486 67.0097 28.8707 67.7493 28.8707 68.8176C28.8707 69.8757 29.5486 70.6461 30.658 70.6461Z"
        fill="currentColor"
      />
      <path
        d="M23.3657 72.033C20.6025 72.033 19 70.3792 19 68.2529C19 66.0444 20.7154 64.4111 23.4376 64.4111C24.6188 64.4111 25.5536 64.6988 26.2829 65.161V66.7224C25.6666 66.2498 24.814 65.9006 23.7354 65.9006C21.9378 65.9006 20.8593 66.8662 20.8593 68.2015C20.8593 69.5369 21.9481 70.523 23.7457 70.523C24.7832 70.523 25.6871 70.1841 26.324 69.6499V71.1496C25.4612 71.766 24.5367 72.033 23.3657 72.033Z"
        fill="currentColor"
      />
    </svg>
  );
}
